/**
 * キーは ApiError.errorCode に対応する（SpiffArena の error_code、
 * または正規化時のフォールバック `http_<status>`）。
 * 未知の errorCode は fallback を表示する。
 */
export default {
  fallback: "処理に失敗しました。時間をおいて再度お試しください。",
  network: "サーバーに接続できませんでした。通信状態をご確認ください。",
  http_400: "リクエストの内容が正しくありません。",
  http_401: "セッションの有効期限が切れました。再度ログインしてください。",
  http_403: "この操作を行う権限がありません。",
  http_404: "対象が見つかりませんでした。",
  http_409: "他の操作と競合しました。画面を更新してお試しください。",
  http_500: "サーバーでエラーが発生しました。",
  http_503: "サーバーが一時的に利用できません。",
  missing_form_file: "この作業はこの画面から実行できません。",
  error_suspended: "案件が一時停止中のため操作できません。",
} as const;
